import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseDeleteEstablishmentLeadMaintenanceSpecialtyProps {
  id?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useDeleteEstablishmentLeadMaintenanceSpecialty = ({
  id,
  onSuccess,
  onError,
}: UseDeleteEstablishmentLeadMaintenanceSpecialtyProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteEstablishmentLeadMaintenanceSpecialty'],
    mutationFn: (maintenanceSpecialtyId: string) => {
      const lead = {
        maintenance_specialty_attributes: {
          id: maintenanceSpecialtyId,
          _destroy: true,
        },
      }

      return privateAxios.put(`/funnel/establishment/leads/${id}/update_maintenance_models`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
